import { render, staticRenderFns } from "./px-edit-panel.vue?vue&type=template&id=25b1b582&scoped=true&"
import script from "./px-edit-panel.vue?vue&type=script&lang=ts&"
export * from "./px-edit-panel.vue?vue&type=script&lang=ts&"
import style0 from "./px-edit-panel.vue?vue&type=style&index=0&id=25b1b582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b1b582",
  null
  
)

export default component.exports